
export const coberturasRequeridas = [1,3,213,214,215,9,10,11,36,44,468];
export const coberturasOpcionales = [];

export const coberturaEquipoEspecial = 0;
export const coberturaDeducibleCero = 0;
export const coberturaServiciosDentales = 0;




const getCatalogText = (catalogs, name, value) => {
    if (catalogs[name] != null) {
        let c = catalogs[name].find(x => x.value == value);
        if (c != null)
            return c.text;
    }
    return '';
}


export const buildTarificacionData = (planId, t) => {
    console.log(t);

    let data = {
        itipopol: 'I',
        VigenciaPol: 'A',
        ...t,
        cate: t.auCategoria,
        nasiento: t.auNumPasajeros,
        valn: t.auValorNuevo,
        valnreal: t.auValorNuevo,
        suma: t.auValorNuevo,
        tipo: t.auTipo,
        coverageIds: "[1,3,213,214,215,9,10,11,36,44,468]",
        Cob1: 1,
        Cob3: 1,
        Cob213: 1,
        Cob214: 1,
        Cob215: 1,
        Cob9: 1,
        Cob10: 1,
        Cob11: 1,
        Cob36: 1,
        Cob218: 0,
        Cob219: 0,
        Cob220: 0,
        Cob221: 0,
        Cob44: 1,
        Cob43: 0,
        Cob80: 0,
        Cob118: 0,
        Cob468: 1,
        codigo1: 0,
        codigoAut: 0,
    }


    return data;
}

export const bulidDataToSave = (poliza, t, catalogos) => {

    let getfrecuencia = (n) => {
        switch (n) {
            case 12: return 'M'
            case 4: return 'T'
            case 2: return 'S'
            case 1: return 'A'
            default: return 'A'
        }
    }

    const isNullOrEmpty = (s) => s == null || s == '';

    poliza.polCobs.forEach(x => {
        x.mPrimaBruta = parseFloat(x.prima).toFixed(2);
    });

    return {
        ...poliza,
        sa: t.suma,
        plan: poliza.planId,
        beneficiarios: [],
        respuesta: [],
        itipopol: 'I',
        cuotas: poliza.ncuotas,
        frecuencia: getfrecuencia(poliza.ncuotas),
        formaPagos: {},
        asegurado: {
            tipoId: (poliza?.asegurado?.tipoId) ?? 3,
            numId: isNullOrEmpty(poliza?.asegurado?.numId) ? '000-010100-0000J' : poliza?.asegurado.numId,
            nombre: isNullOrEmpty(poliza?.asegurado?.nombre) ? 'prueba' : poliza?.asegurado.nombre,
            apellido: isNullOrEmpty(poliza?.asegurado?.apellido) ? 'prueba' : poliza?.asegurado.apellido,
            estadoCivil: 0,
            fechaNacimiento: '2021-12-27',
            profesion: 0,
            ocupacion: 0,
            sexo: 'M',
            actividad: 0,
            origenFondos: 0,
            OrigenFondosDetalle: '',
            Direccion: '',
            Departamento: 0,
            Municipio: 0,
            TelefonoCasa: '',
            TelefonoCelular: poliza?.asegurado?.TelefonoCelular,
            Email: poliza?.asegurado?.email,
            CasaPropia: null,
            TieneHijos: null,
            VehiculoPropio: null,
            NombreEmp: '',
            TelefonoEmp: '',
            ...poliza.asegurado
        },
        au: {
            tipo: 'AU',
            ramo: 1,
            sa: t.suma,
            auMarca: getCatalogText(catalogos, 'marcas', t.marc),
            auModelo: getCatalogText(catalogos, 'modelos', t.mode),
            auAnio: t.anio,
            auTipo: t.auTipo,
            auCategoria: t.auCategoria,
            auValorNuevo: t.valn,
            auNumPasajeros: t.auNumPasajeros,
            auUso: t.usoo,
            cia: 3,
            codigoMarca: t.marc,
            codigoModelo: t.mode,
            auGPS: t.GPS,
            auNuevo: t.auNuevo,
            ideducible: t.dedu,
            irastreoSatelital: t.rsat
        }
    };
}
